<template>
  <section v-if="!loading" class="section-adopt" data-testid="wrapper">
    <h2 class="adopt-title">全国の医療機関で採用されています</h2>
    <div class="adopt-slider">
      <div class="adopt-slider-wrap">
        <ul class="adopt-slider-list">
          <li
            v-for="(column, columnIndex) in sliderColumns"
            :key="columnIndex"
            class="slider-item"
          >
            <figure
              v-for="(medicalInstitution, rowIndex) in column"
              :key="`${medicalInstitution.slug}-${rowIndex}`"
              class="slider-item-img"
            >
              <img
                :src="medicalInstitution.lpLogoImageUrl"
                :alt="medicalInstitution.name"
              />
            </figure>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onBeforeMount,
  onBeforeUnmount,
  ref,
  nextTick,
} from 'vue';
import { useStore } from '../stores';
import { slider, DEFAULT_SLIDE_SPEED } from '../modules/top';
import { splitIntoColumns } from '../utils/array';

const ROW_COUNT = 3;

export default defineComponent({
  setup() {
    const loading = ref(false);
    const store = useStore();
    let cleanupSlider: (() => void) | null = null;
    let isUnmounted = false;

    onBeforeMount(async () => {
      loading.value = true;

      const response = await store.fetchMedicalInstitutions();

      if (isUnmounted) {
        return;
      }

      if (response) {
        loading.value = false;
        await nextTick();
        cleanupSlider = slider({ slideSpeed: DEFAULT_SLIDE_SPEED / 2 });
      }
    });

    onBeforeUnmount(() => {
      isUnmounted = true;
      if (cleanupSlider) {
        cleanupSlider();
      }
    });

    const sliderColumns = computed(() =>
      splitIntoColumns(store.medicalInstitutions, ROW_COUNT),
    );

    return {
      loading,
      sliderColumns,
    };
  },
});
</script>

<style scoped>
.section-adopt {
  z-index: 0;
  position: relative;
}

.adopt-title {
  font-size: 1rem;
  letter-spacing: 0.06em;
  line-height: 1.5;
  text-align: center;
  margin-bottom: 0.75rem;
  padding: 0 1.25rem;
  @media (--md-top) {
    font-size: 1.25rem;
    margin-bottom: 1.25rem;
  }
}

.adopt-slider {
  position: relative;
  overflow: hidden;
}

.adopt-slider-wrap {
  top: 0;
  left: 0;
  position: absolute;
  display: flex;
}

.adopt-slider-list {
  display: flex;
}

.slider-item {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-right: 1.5rem;
}

.slider-item-img {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 210px;
  height: 95px;
  padding: 10px;
  box-sizing: border-box;
  background: var(--white);
  border: 1px solid #eaeaea;
  border-radius: 0.5rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
